import { is_military_address } from 'app/helpers/AddressHelpers'
import country_name_from_alpha2 from 'app/helpers/CountryHelpers'
import _ from 'lodash'
import filter from 'lodash/filter'

export default class ShippingMethodService {

  constructor(httpService) {
    this.onchangeCallbacks = []
    this.shippingMethods = []
    this.availableShippingMethods = []
    this.address = {}
    this.loaded = false
    this.$http = httpService
  }

  updateAddress(address) {
    return new Promise((resolve, reject) => {
      this.address = address
      this.address.country_name = country_name_from_alpha2(address.country)

      if (this.address.country_name == "" || this.address.region == "") {
        reject("invalid address")
        return
      }

      if (this.loaded) {
        resolve(this.updateAvailableShippingMethods())
      } else {
        this.$http.get('/shipping_methods').then((response) => {
          const json = response.body
          this.shippingMethods = json.shipping_methods
          this.defaultFulfillers = json.default_fulfillers
          resolve(this.updateAvailableShippingMethods())
        }, response => {
          reject("Error getting shipping details")
        })
      }
    })
  }

  // callback receives newMethods,
  // which are all the shipping methods
  // available based on address
  onChange(callback) {
    this.onchangeCallbacks.push(callback)
  }

  estimated_delivery_text(shippingMethod) {
    return `Estimated delivery by ${shippingMethod.estimated_delivery}`
  }

  fulfiller() {
    return this.defaultFulfillers[this.address.country_name]
  }

  find(shippingMethodId) {
    let match = null
    this.availableShippingMethods.forEach((shippingMethod) => {
      if (parseInt(shippingMethodId) == shippingMethod.id) {
        match = shippingMethod
      }
    })

    return match
  }

  updateAvailableShippingMethods() {
    if (!this.shippingMethods || this.shippingMethods.length === 0) return []

    let shippingMethods = _.cloneDeep(this.shippingMethods) // clone objects in array so we can modify properties

    // Only shipping methods for this country
    shippingMethods = filter(shippingMethods, (shippingMethod) => {
      return shippingMethod.country === this.address.country_name
    })

    // Only shipping methods for the enabled fulfiller
    let enabledFulfiller = this.fulfiller()
    shippingMethods = filter(shippingMethods, (shippingMethod) => {
      return shippingMethod.fulfiller === enabledFulfiller
    })

    // Disable non-standard shipping methods for military addresses
    if (enabledFulfiller == 'north_of_you' && is_military_address(this.address.region)) {
      shippingMethods.forEach((shippingMethod) => {
        if (shippingMethod.name === 'Standard Shipping') {
          shippingMethod.notes = 'APO/FPO/DPO addresses may take up to 14 business days'
        } else {
          shippingMethod.notes = `APO/FPO/DPO not eligible for ${shipping_method.name}`
          shippingMethod.disabled = true
        }
      })
    }

    // Disable Express for Hawaii & Alaska
    if (this.address.region == 'Hawaii' || this.address.region == 'Alaska') {
      shippingMethods.forEach((shippingMethod) => {
        if (shippingMethod.name == 'Express Shipping') {
          shippingMethod.disabled = true
          shippingMethod.notes = `Express orders cannot be shipped to ${this.address.region}`
        }
      })
    }

    this.availableShippingMethods = filter(shippingMethods, (sm) => !sm.disabled)

    // notify observers
    this.onchangeCallbacks.forEach(callback => callback(this.availableShippingMethods))
    return this.availableShippingMethods
  }
}
